import { render, staticRenderFns } from "./modal-forget-pass-confirm.vue?vue&type=template&id=f2531434"
import script from "./modal-forget-pass-confirm.vue?vue&type=script&lang=js"
export * from "./modal-forget-pass-confirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports